module.exports = __webpack_public_path__ + "img/passo01@2x.d8e38b3f.png";